import { linkListStyles } from "@insite/content-library/Widgets/Basic/LinkList";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(linkListStyles, {
    ...linkListStyles,
    linkListWrapper: {
        css: css`
            text-transform: capitalize;
            padding: 10px 0;
        `,
    },
    titleWrapper: {
        css: css`
            font-weight: bold;
        `,
    },
    linkWrapper: {
        css: css`
            padding: 1px 18px 0 0;
            line-height: 36px;
            font-size: 15px;
            a {
                span {
                    color: #000 !important;
                }
            }
        `,
    },
});
